import * as React from "react";
import {cx} from "emotion";

import "./grid-view-card.scss";

import {cs}         from "@Common/react/chain-services";
import {formatDate} from "@Common/ui-components/format-date";

import {Tooltip}      from "../../../common/tool-tip";
import {ImageSvg}     from "../../common/images/image-svg";
import {ImageGallery} from "../common/image-gallery/image-gallery";

import {formatFlexMoney} from "./format-flex-money";

export const GridViewCard = ({record, onCreateMarketingMaterials}) => cs(
    ({}) => (
        <div className={cx("grid-view-card-5iw card")}>
            <Tooltip/>
            <div className="image-gallery">
                <ImageGallery {...{pictures: record.thumbPictures}}/>

                <div className="image-info">
                    <div className="item grid-mls-id" data-tip={record.mlsId ?? "N/A"}>
                        ID:{" "}
                        <span xd-qa-type="label" xd-qa-name={record.mlsId+" - ID"}>{record.mlsId ?? "N/A"}</span>
                    </div>
                </div>
            </div>

            <div className="details">
                <div 
                    className="address"
                    data-tip={record.streetAddress + ', ' + record.city + (record.state ? (', ' +record.state) : "") + (record.zip ? ( ' ' + record.zip ) : "")}
                    xd-qa-type="label"
                    xd-qa-name={record.mlsId+" - Address"}
                >
                    {record.streetAddress}
                    <br/>
                    {record.city}
                    {record.state && ", " + record.state}
                    {record.zip && " " + record.zip}
                </div>
                <div className="info">

                    <div className="line">
                        <label>Price:</label>
                        <div className="value" xd-qa-type="label" xd-qa-name={record.mlsId+" - Price"}>{formatFlexMoney(record.listedPrice)}</div>
                    </div>
                    <div className="line">
                        <label>Date Listed:{" "}</label>
                        <div className="value">
                            <div className="line" xd-qa-type="label" xd-qa-name={record.mlsId+" - Date Listed"}>
                                {formatDate(record.dateListed)}
                            </div>
                        </div>
                    </div>
                    <div className="line">
                        <label>Date Sold:{" "}</label>
                        <div className="value">
                            <div className="line" xd-qa-type="label" xd-qa-name={record.mlsId+" - Date Sold"}>
                                {formatDate(record.dateSold)}
                            </div>
                        </div>
                    </div>
                    <div className="line">
                        <label>Agent:</label>
                        <div 
                            className="value"
                            data-tip={record.agentLastName ? (record.agentFirstName + ' ' + record.agentLastName): "N/A"}
                            xd-qa-type="label"
                            xd-qa-name={record.mlsId+" - Agent"}
                        >
                            {record.agentLastName ? (record.agentFirstName + ' ' + record.agentLastName): "N/A"}
                        </div>
                    </div>

                </div>
                <div className="action-btns">
                    <button
                        className="marketing-materials"
                        onClick={() => onCreateMarketingMaterials(record)}
                        xd-qa-type="button"
                        xd-qa-name="Create Marketing Materials"
                    >
                        Create Marketing Materials
                    </button>
                </div>
            </div>
        </div>
    )
);